const Analytics = {
	init: (user) => {
		return null;
	},

	setUser: (userId) => {
		return null;
	},

	event: (eventName, eventProperties) => {
		return null;
	},
};

export default Analytics;
